import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonConstants } from 'src/app/constants/commonConstants';
import { EnvironmentService } from 'src/app/services/environment/environment.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  fgtPwdForm: FormGroup;
  submitted = false;

  constructor(private formBuilder: FormBuilder,
    private environmentService: EnvironmentService) { }

  ngOnInit(): void {
    this.fgtPwdForm = this.formBuilder.group({
      emailId: new FormControl('', [Validators.required, Validators.email])
    });
    (document.getElementById('companyLogo') as HTMLImageElement).src = CommonConstants.imageBasePath + this.environmentService.getCompanyLogo();
  }

  get form() { return this.fgtPwdForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.fgtPwdForm.invalid){
      return;
    }
  }

}
